import Notification from 'flarum/forum/components/Notification';
import app from 'flarum/forum/app';

export default class MentorBindingApprovedNotification extends Notification {
  icon() {
    return 'fas fa-check-circle';
  }

  href() {
    const user = app.session.user;
    return user ? app.route('user.taroMentors', { username: user.slug() }) : '#';
  }

  content() {
    const fromUser = this.attrs.notification.fromUser();
    const name = fromUser ? fromUser.displayName() : '导师';
    return name + ' 已通过你的拜师申请';
  }

  excerpt() {
    return null;
  }
}
